import api from '.';

import { buildQueryWithParams, makeListTags } from '../../Utils/api';

const tagType = 'chargingPoint';

const chargingPointsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    requestChargingPointsForId: builder.query({
      query: (data) => ({
        url: '/chargers/with-sessions-user-id',
        method: 'POST',
        body: data
      }),
      transformResponse: (res) => ({
        list: res.chargingPoints
      })
    }),
    requestChargingPoints: builder.query({
      query: (filter) => ({
        url: '/charge-points',
        method: 'GET',
        params: { filter }
      })
    }),
    requestChargingPointsForPayment: builder.query({
      query: ({ cp_id }) => ({
        url: buildQueryWithParams('/chargers/charger-point', { cp_id })
      }),
      transformResponse: (res) => ({
        cp: res.chargingPoint
      })
    }),
    requestAllChargingPoints: builder.query({
      query: (params) => ({
        url: buildQueryWithParams('/charge-points'),
        method: 'GET',
        params: params
      }),

      transformResponse: (res) => {
        const { chargers, ...rest } = res;
        return { list: res };
      },

      providesTags: makeListTags(tagType)
    }),

    requestAllChargingPointsById: builder.query({
      query: ({ organizationId, filter }) => ({
        url: `/charge-points`,
        method: 'GET',
        params: { filter }
      })
    }),

    requestDateRangeChargingPoints: builder.query({
      query: ({ filter, orgId }) => ({
        url: `/organizations/${orgId}/charge-points`,
        params: { filter }
      }),
      transformResponse: (res) => ({
        list: res
      })
    }),
    updateChargingPoint: builder.mutation({
      query: (params) => ({
        url: `/charge-points/${params.id}`,
        method: 'PATCH',
        body: params.data
      }),
      onQueryStarted: async ({ ...params }, { dispatch, queryFulfilled }) => {
        const { data, cacheParams } = params;
        const results = dispatch(
          api.util.updateQueryData(
            'requestAllChargingPoints',
            cacheParams,
            (requestedChargingList) => {
              const index = requestedChargingList.list.findIndex(
                (item) => item.id === data.id || item._id === data.id
              );
              Object.keys(data).forEach((key) => {
                if (data[key]) {
                  requestedChargingList.list[index][key] = data[key];
                }
              });
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (err) {
          results.undo();
        }
      }
    }),
    createChargingPoint: builder.mutation({
      query: (data) => ({
        url: '/charge-points',
        method: 'POST',
        body: data
      }),
      invalidatesTags: [tagType]
    }),

    createAdminChargingPoint: builder.mutation({
      query: ({ postData, orgId }) => ({
        url: `/organizations/${orgId}/charge-points`,
        method: 'POST',
        body: postData
      }),
      invalidatesTags: [tagType]
    }),

    deleteChargingPoint: builder.mutation({
      query: (id) => ({
        url: `/charge-points/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [tagType]
    }),

    deleteAdminChargingPoint: builder.mutation({
      query: ({ params }) => {
        const whereCondition = params?.filter?.where || params?.where;

        return {
          url: `/organizations/${params.id}/charge-points?where=${JSON.stringify(whereCondition)}`,
          method: 'DELETE'
        };
      },
      invalidatesTags: [tagType]
    }),

    createChargingPointConfiguration: builder.mutation({
      query: ({ data, id }) => ({
        url: `charge-points/${id}/charge-point-configuration`,
        method: 'POST',
        body: data
      }),
      transformResponse: (res) => ({
        res
      })
    }),
    createAdminChargingPointConfiguration: builder.mutation({
      query: ({ data, id }) => ({
        url: `charge-points/${id}/charge-point-configuration`,
        method: 'POST',
        body: data
      }),
      transformResponse: (res) => ({
        res
      })
    }),

    updateChargingPointConfiguration: builder.mutation({
      query: ({ data, id }) => ({
        url: `charge-points/${id}/charge-point-configuration`,
        method: 'PATCH',
        body: data
      }),
      transformResponse: (res) => ({
        res
      })
    }),
    chargingPointsCount: builder.query({
      query: () => ({
        url: '/charge-points/count',
        method: 'GET'
      })
    })
  })
});
export default chargingPointsApi;
export const {
  useLazyRequestChargingPointsQuery,
  useRequestChargingPointsForIdQuery,
  useRequestChargingPointsForPaymentQuery,
  useRequestAllChargingPointsQuery,
  useCreateChargingPointMutation,
  useChargingPointsCountQuery,
  useCreateAdminChargingPointMutation,
  useDeleteChargingPointMutation,
  useRequestDateRangeChargingPointsQuery,
  useLazyRequestDateRangeChargingPointsQuery,
  useCreateChargingPointConfigurationMutation,
  useUpdateChargingPointConfigurationMutation,
  useCreateAdminChargingPointConfigurationMutation,
  useUpdateChargingPointMutation,
  useDeleteAdminChargingPointMutation,
  useRequestAllChargingPointsByIdQuery
} = chargingPointsApi;
